import { useEffect } from "react";
import { useAnalyticsStore } from "../store";

/**
 * Clears the analytics filters when the page unmounts.
 *
 * Reading the deep link's `?story=`/`?version=` params used to happen here too,
 * inside a `useState` initializer — a store write and a `history.replaceState`
 * performed during render, which React 18 is free to discard and replay. The
 * ids now come from the store's initial state (derived from the URL), so this
 * hook only owns the teardown, and the reset is safe because the URL still
 * holds the selection for the next mount to re-derive.
 */
export const useResetStore = () => {
  const reset = useAnalyticsStore((s) => s.reset);

  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);
};
